import css from './index.module.scss';
import { Button } from '@components/base';
import PickupAndDelivery from './components/pickup-and-delivery';
import Identifiers from './components/Identifiers';
import CustomerOrderInformation from './components/customer-order-information';
import CommodityInformation from './components/commodity-information';
import { useFormContext } from 'react-hook-form';
import { IBillOfLadingState } from '../../bol';

interface IShipmentDetailsProps {
  handleShipmentDetailsSubmit: () => void;
  handleCancelClick: () => void;
  data: IBillOfLadingState;
}

const ShipmentDetails = (props: IShipmentDetailsProps) => {
  const { data, handleShipmentDetailsSubmit, handleCancelClick } = props;
  const { warehouseOptions, customerOrderInformation, commodityInformation, customerPocOptions } =
    data;
  const { handleSubmit } = useFormContext();
  return (
    <form
      noValidate
      onSubmit={handleSubmit(handleShipmentDetailsSubmit)}
      className={css.mainWrapper}
    >
      <PickupAndDelivery
        warehouseOptions={warehouseOptions}
        customerPocOptions={customerPocOptions}
      />
      <Identifiers />
      <CustomerOrderInformation data={customerOrderInformation} />
      <CommodityInformation data={commodityInformation} />
      <div className={css.formActionWrapper}>
        <Button variant="text" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button type="submit">Save and Proceed</Button>
      </div>
    </form>
  );
};

export default ShipmentDetails;
